var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"topbar-icon"},[_c('span',{directives:[{name:"tippy",rawName:"v-tippy",value:({theme:'small-black'}),expression:"{theme:'small-black'}"}],attrs:{"content":_vm.label}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }